import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCapitolConfig } from '@/services/admin/update-capitol-config';
import { useNodeStore } from '@/stores/node-store';

interface UpdateCapitolConfigParams {
  orgId: string;
  items: Record<string, boolean>;
}

export const useUpdateCapitolConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ orgId, items }: UpdateCapitolConfigParams) =>
      updateCapitolConfig(orgId, items),
    onSuccess: (data, { orgId }) => {
      queryClient.setQueryData(['org-node-access-config', orgId], data);
      void queryClient.invalidateQueries({
        queryKey: ['org-admin-catalog', orgId],
      });
      useNodeStore.getState().clearNodeCache();
    },
  });
};
